<template>
  <div style="margin-top: 30px">
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item
              label="实际承运人"
              prop="driverName"
              style="margin-right: 15px"
            >
              <el-input
                v-model="form.driverName"
                readonly
                @focus="showSelectDriverFunc"
              >
                <el-button
                  slot="append"
                  icon="el-icon-plus"
                  @click="showSelectDriverFunc"
                />
              </el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">取 消</el-button>
      <el-button type="primary" @click="funcSubmit">确 定</el-button>
    </div>
    <vxe-modal
      v-model="selectDriverFlag"
      title="选择实际承运人"
      width="800"
      height="auto"
      resize
      remember
      @close="closeFn"
    >
      <SelectDriver
        ref="selectDriverRef"
        @fatherSubmitMethod="fatherSubmitFunc"
        @fatherCancelMethod="fatherCancelFunc"
      />
    </vxe-modal>
  </div>
</template>
<script>
import request from "@/utils/request";
import SelectDriver from "@/views/basicInfo/driver/SelectOne.vue";
/**
 * 待运输调单 管理员和托运人选择独立实际承运人和车队，车队长选择车队内实际承运人，提交调用dispatchOrderDetail
 * 运输中调单 管理员选择所有独立实际承运人和所有车队实际承运人，车队长选择车队内实际承运人，提交调用dispatchInTransit
 */
export default {
  components: {
    SelectDriver
  },
  props: {
    type: {
      type: Number,
      default: 0 // 0 待运输 1运输汇总
    }
  },
  data() {
    return {
      selectDriverFlag: false,
      pageType: "exchange",
      form: {
        driverName: "",
        branchCode: ""
      },
      rules: {
        driverName: [
          { required: true, message: "请选择实际承运人", trigger: "change" }
        ]
      }
    };
  },
  created() {
    this.roles = this.$store.getters.roles;
    const isAdmin =
      this.roles.indexOf("SUPER_ADMIN") > -1 ||
      this.roles.indexOf("PLAT_ADMIN") > -1 ||
      this.roles.indexOf("STAFF") > -1;
    const isShipment =
      this.roles.indexOf("SHIPMENT") > -1 ||
      this.roles.indexOf("SHIPMENT_COMPANY") > -1; // 托运人
    this.isShipmentOrAdmin = isAdmin || isShipment;
  },
  methods: {
    closeFn() {
      this.$refs.selectDriverRef.close();
    },
    init(entity) {
      this.form.driverName = "";
      this.form.driverCode = "";
      this.form.code = entity.code;
      this.form.branchCode = entity.branchCode;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          const data = this.form;
          let url = "";
          if (this.type === 1) {
            url = "ntocc-tms-api/orderDetail/dispatchOrderDetail"; // 待运输
          } else if (this.type === 2) {
            url = "ntocc-tms-api/orderDetail/dispatchInTransit"; // 运输中
          }
          request({
            url,
            method: "put",
            params: data
          })
            .then(response => {
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherSubmitMethod", this.pageType);
              rLoading.close();
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", this.pageType);
      this.form.driverName = "";
      this.form.driverCode = "";
    },
    showSelectDriverFunc() {
      this.selectDriverFlag = true;
      let url = "";
      if (this.isShipmentOrAdmin) {
        // alert(this.type)
        if (this.type === 1) {
          // 待运输
          url = "driver/driverList"; // 获取独立实际承运人和车队信息
        } else if (this.type === 2) {
          // 运输中
          url = "driver/inTransitDriverList"; // 获取独立实际承运人和车队实际承运人
        }
        this.$refs.selectDriverRef.init({
          url: url,
          driverType: 6,
          authStatusExt: 3,
          branchCodeExt: this.form.branchCode
        });
      } else {
        this.$refs.selectDriverRef.init({
          url: "driver/inTransitDriverList", // 车队长获取本车队实际承运人
          isTeamSendDetail: 1,
          authStatusExt: 3,
          branchCodeExt: this.form.branchCode
        });
      }
    },
    fatherSubmitFunc(row) {
      this.form.driverCode = row.driverCode;
      this.form.driverName = row.name;
      this.form.vehicleCode = row.vehicleCode;
      if (this.type === 2) {
        // 运输中，需要传递teamCode
        this.form.teamCode = row.teamCode;
      }
      this.selectDriverFlag = false;
    },
    fatherCancelFunc() {
      this.selectDriverFlag = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
